import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const Newsletter = () => {
  return (
    <section className="py-24 bg-frost-vanilla relative overflow-hidden">
      <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/4 w-[600px] h-[600px] bg-frost-ice rounded-full blur-3xl opacity-30"></div>
      
      <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
        <div className="bg-white p-12 md:p-20 rounded-[3rem] shadow-2xl shadow-frost-berry/5 border border-frost-ice">
          <div className="inline-flex p-4 bg-frost-ice rounded-2xl mb-8">
            <SafeIcon icon="FiMail" className="text-3xl text-frost-berry" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Join the Chill List</h2>
          <p className="text-gray-500 text-lg mb-10">
            Be the first to know about new flavor drops, limited edition gift boxes, and seasonal preorders.
          </p>
          
          <form className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto" onSubmit={(e) => e.preventDefault()}>
            <input 
              type="email" 
              placeholder="Enter your email" 
              className="input-field"
            />
            <button className="btn-primary whitespace-nowrap">
              Stay Cool
            </button>
          </form>
          <p className="mt-6 text-xs text-gray-400">
            No spam, just sweet updates. Unsubscribe anytime.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;